<template>
<el-popover placement="top-start" title="" trigger="hover">
  <img class="code-image" :src="codeImageUrl" />
  <div style="text-align: center">{{title}}</div>
  <div slot="reference">
    <img style="width:50px; height:50px;" :src="iconImageUrl">
  </div>
</el-popover>
</template>

<script>
export default {
  name: 'QRCodePop',
  props: {
    codeImageUrl: {
      type: String
    },
    iconImageUrl: {
      type: String
    },
    title: {
      type: String
    }
  },
}
</script>

<style lang="stylus" scoped>

</style>